<template>
  <div class="menu-item-sources-field">
    <fields-group :label="label">
      <loader
        v-if="isLoading"
        absolute
      />
      <sources-select-field
        :value="selectedSources"
        :items="allSources"
        class="menu-item-sources-select"
        empty-text="Выберите источники для блюда"
        hint="Внимание! При удалении источника из списка, удаляются его параметры"
        @input="emitSelectSources"
      />

      <v-tabs
        background-color="#F1F1F1FF"
        vertical
      >
        <v-tab
          v-for="menuItemSource in value"
          :key="`tab-${menuItemSource.sourceId}`"
        >
          {{ menuItemSource.source.name }}
        </v-tab>

        <v-tab-item
          v-for="menuItemSource in value"
          :key="`tab-item-${menuItemSource.sourceId}`"
        >
          <fields-group class="menu-item-sources-options">
            <div class="menu-item-sources-options__row">
              <v-text-field
                v-model="menuItemSource.marketingName"
                label="Маркетинговое название"
                :placeholder="menuItem.name"
                outlined
              />
            </div>
            <div class="menu-item-sources-options__row">
              <v-textarea
                v-model="menuItemSource.marketingDescription"
                label="Маркетинговое описание"
                :placeholder="menuItem.composition"
                outlined
              />
            </div>
            <div class="menu-item-sources-options__row">
              <v-text-field
                v-model="menuItemSource.priceRub"
                :placeholder="`${menuItem.priceRub}`"
                label="Цена"
                outlined
              />
            </div>
            <div class="menu-item-sources-options__row">
              <upload-image
                v-model="menuItemSource.marketingImage"
                color="orange"
                label="Изображение в источнике"
              >
                Загрузить фото
              </upload-image>
            </div>
            <div class="menu-item-sources-options__row">
              <v-checkbox
                v-model="menuItemSource.status"
                label="Блюдо активно в источнике"
              />
            </div>
            <!--            <div class="menu-item-sources-options__row">
              <v-checkbox
                v-model="menuItemSource.required"
                label="Блюдо обязательно для всех филиалов"
              />
            </div>-->
            <menu-item-to-filials-field
              v-model="menuItemSource.filials"
              :all.sync="menuItemSource.required"
              :loading="loading"
              :disabled="loading"
            />
          </fields-group>
        </v-tab-item>
      </v-tabs>
    </fields-group>
  </div>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'
  import SourcesSelectField from '@/components/ui/crud/fields/menu-item-sources/SourcesSelectField.vue'
  import SourceDataService from '@/services/api/SourceDataService'
  import UploadImage from '@/components/UploadImage.vue'
  import MenuItemToFilialsField from '@/components/ui/crud/fields/MenuItemsToFilialsField.vue'

  export default {
    name: 'MenuItemSourcesField',
    components: {
      MenuItemToFilialsField,
      UploadImage,
      SourcesSelectField,
      FieldsGroup,
    },
    props: {
      value: {
        type: Array,
        default: null,
      },
      menuItem: {
        type: Object,
        default: () => ({}),
      },
      label: {
        type: String,
        default: 'Источники',
      },
      emptyText: {
        type: String,
        default: null,
      },
      enumClass: null,
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        currentTab: null,
        allSources: [],
        listLoading: false,
      }
    },
    computed: {
      isLoading () {
        return this.loading || this.listLoading
      },
      selectedSources: {
        get () {
          return this.value.map((item) => item.sourceId)
        },

      },

    },
    watch: {

    },
    async created () {
      await this.loadAllSources()
    },
    methods: {
      async loadAllSources () {
        this.listLoading = true
        try {
          this.allSources = await SourceDataService.getList()
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.listLoading = false
      },
      getExistMenuItemSource (sourceId) {
        return this.value.find(item => item.sourceId === sourceId)
      },
      getEmptyMenuItemSource (source) {
        return {
          editableInFilial: true,
          marketingDescription: null,
          marketingImage: null,
          marketingImageUrl: null,
          marketingName: null,
          price: null,
          priceRub: null,
          required: false,
          status: true,
          sourceId: source.id,
          source: source,
          filials: [],
        }
      },
      emitSelectSources (value) {
        console.log('emitSelectSources', value)

        const res = this.allSources
          .filter((item) => value.includes(item.id))
          .map((source) => {
            let menuItemSource = this.getExistMenuItemSource(source.id)

            if (!menuItemSource) {
              menuItemSource = this.getEmptyMenuItemSource(source)
            }

            return menuItemSource
          })
        console.log(res)
        this.$emit('input', res)
      },
    },
  }
</script>

<style scoped lang="less">

.menu-item-sources-select {
  margin-bottom: 20px;
}

.menu-item-sources-options {
  margin-bottom: 0;
  border-color: #ccc;

  &__row {
    margin-bottom: 15px;
  }
}
</style>
